export const BLACK_HOLE_DISK_PLANE_X = Math.PI / 2;
export const BLACK_HOLE_DISK_PLANE_Z = 0;
